<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="width">
    <v-card>
      <v-card-text v-if="itemDetail">
        <v-layout>
          <v-flex xs6>
            <v-select :items="categoryList"
                      item-text="value"
                      item-value="key"
                      v-model="changeCategory"
                      label="專案歸類"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6>
            <v-select :items="caseTypeList"
                      item-text="text"
                      item-value="key"
                      v-model="promotionType"
                      label="業務別"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select :items="promotionList"
                      item-text="text"
                      item-value="key"
                      v-model="promotionNo"
                      label="專案"
            ></v-select>
          </v-flex>
        </v-layout>

        <!-- 原融-->
        <template v-if="parseInt(itemDetail.category) === 0 || parseInt(itemDetail.category) === 1 || parseInt(itemDetail.category) === 3">
          <v-layout>
            <v-flex>
              <v-checkbox
                v-model="needChangeCheckList"
                label="變更條件"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <div class="row mt-2" v-if="info">
            <span class="title">調整條件</span><br/>
            <div class="title mt-2">
              目前條件：超優 {{ info.header.caseType5 }} | 優加 {{ info.header.caseType }} |  優質 {{ info.header.caseType4 }}
<!--              <v-checkbox v-model="info.header.caType[2].value" label="一般"></v-checkbox>-->
            </div><br/>
            <div v-if="needChangeCheckList">
              <v-layout v-for="(item, i) in getRequireCheckList" :key="item.key">
                <v-flex xs12>
                  <span class="subheading">{{item.title}}</span>
                  <v-checkbox class="title" v-model="requireOption[i].value" :label="item.text"></v-checkbox>
                </v-flex>
              </v-layout>
              <hr>
              <v-layout row wrap v-for="item in getCheckList" :key="item.key">
                <v-flex xs12>
                  <span class="title">{{item.title}}</span>
                  <v-checkbox class="title" v-if="requireOption[0].value === true && item.key === 6" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else-if="requireOption[1].value === true && item.key === 3" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else-if="itemDetail.productId === '1' && item.key === 8" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else-if="itemDetail.productId === '2' && item.key === 9" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else v-model="item.value" :label="item.text"></v-checkbox>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </template>
        <!-- 商品-->
        <template>

        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn v-if="showCancel"  class="red" dark text @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text :loading="saveLoading" :disabled="isSuccess" @click="confirmEvent">確定變更</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MobileDetect from 'mobile-detect';
import dateTimeTool from '../components/dateTimeTool';
import common from '../mixins/common';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'ChangeCaseNoView',
  components:{
    dateTimeTool
  },
  props: {
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      requireOption:[{
        value: false,
      },
        {
          value: false,
        }],
      isSuccess: false,
      width: md.phone() ? '100%':'50%',
      saveLoading: false,
      messageDialog: {
        visible: false,
        title: '',
        content: '',
      },
      promotionType:'',
      promotionNo:'',
      promotionTypeName: '',
      changeCategory: 0,
      showCA20: false,
      info: null,
      needChangeCheckList: false,
    }
  },
  watch:{
    visible(value){
      console.log(`ChangeCaseNoView visible == ${JSON.stringify(this.itemDetail)}`);
      this.promotionType = this.itemDetail.promotionType;
      this.promotionNo = this.itemDetail.promotionNo;
      this.promotionTypeName = this.itemDetail.promotionTypeName;
      this.changeCategory = this.itemDetail.category;
      console.log(`changeCategory == ${this.changeCategory}`);
      this.showCA20 = this.promotionType === 'CA20' || this.promotionType === 'CA21';
      if (value === true){
        this.loadData();
      }
    },
    promotionType(value){
      console.log(`promotionType == ${value}`);
    },
    changeCategory(value){
      console.log(`changeCategory == ${value}`);
    }
  },
  created() {
  },
  mixins:[common],
  computed:{
    caseTypeList(){
      return this.getCaseTypeList;
      // if (this.showCA20){
      //   return this.getCaseTypeList.filter(m=>m.key === 'CA20');
      // } else {
      //   return this.getCaseTypeList.filter(m=>m.key !== 'CA20');
      // }
    },
    categoryList(){
      return [
        { key: 0 , value: '機車原融' },
        { key: 2 , value: '機車N專案' },
      ]
    },
    promotionList() {
      return this.getFinanceCaseList.filter(m=> {
        if (this.promotionType === 'CA21'){
          return m.key === 'DQ71' || m.key === 'DQ72' || m.key === 'DQ73'
          || m.key === 'DR47' || m.key === 'DR48' || m.key === 'DR49'
        } else {
          return m.busType === this.promotionType
        }
      });
    },
  },
  methods:{
    ...mapActions(['changePromotionInfo', 'fetchFinanceCreditInfo', 'saveFinanceCaseType']),
    async loadData(){
      const results = await this.fetchFinanceCreditInfo({ caseId: this.itemDetail.caseId });
      this.info = results[0];
      console.log(`find user ${JSON.stringify(this.info)}`);
    },
    cancelEvent(){
      this.$emit('cancelEvent');
    },
    async changeCheckList(){
      const checkRequireCount = this.requireOption.filter(m=>m.value === true);
      const checkCount = this.getCheckList.filter(m=>m.value === true);
      console.log(`checkCount == ${checkRequireCount.length} / ${checkCount.length} / ${this.editedItem.productId} | ${this.getCheckList[0].value}`);
      let caseType5 = '';
      let caseType = '';
      let caseType4 = '';
      let i = 0;
      let requireContent = '';
      for (let option of this.getRequireCheckList){
        if (this.requireOption[i].value){
          requireContent += `${option.option} `;
        }
        i++;
      }
      if (checkRequireCount.length === 0 && checkCount.length === 1 && this.getCheckList[0].value){ // 優質專案
        for (let item of this.getCheckList){
          if (item.value) {
            requireContent += `${item.key + 1} `;
          }
        }
        caseType4 += requireContent;
      } else if (checkRequireCount.length === 0 && checkCount.length > 1 && this.getCheckList[0].value === false){ // 優質專案
        for (let item of this.getCheckList){
          if (item.value) {
            requireContent += `${item.key + 1} `;
          }
        }
        this.editedItem.header.caseType4 += requireContent;
      }  else if (checkRequireCount.length > 0  || (checkCount.length > 1 && this.getCheckList[0].value === true)){ // 優加專案
        for (let item of this.getCheckList){
          if (item.value) {
            requireContent += `${item.key + 1} `;
          }
        }
        if (checkRequireCount.length > 0){
          caseType5 += requireContent;
        } else {
          caseType += requireContent;
        }
      }
      const result = { caseType, caseType4, caseType5};
      console.log(`result == changeCheckList ${JSON.stringify(result)}`);
      await this.saveFinanceCaseType({
        caseId: this.info.caseId,
        caseType, caseType4, caseType5
      });
    },
    async confirmEvent(){
      if (this.needChangeCheckList){
        await this.changeCheckList();
      }

      this.saveLoading = true;

      let promotionTypeName = '';
      const find = this.getCaseTypeList.find(m=>m.key === this.promotionType);
      if (find){
        promotionTypeName = find.text;
      }

      const item = {
        caseId: this.itemDetail.caseId,
        promotionType: this.promotionType,
        promotionNo: this.promotionNo,
        promotionTypeName: promotionTypeName,
        category: this.changeCategory,
      }
      console.log(`changePromotionInfo ${JSON.stringify(item)}`);

      const res = await this.changePromotionInfo(item);

      const saveResult = res.data;
      console.log(`save changePromotionInfo ${JSON.stringify(saveResult)}`);
      this.saveLoading = false;
      if (saveResult && saveResult.statusCode === 0){
        this.$emit('saveSuccessEvent', saveResult);
      } else {
        this.$emit('saveFailEvent', saveResult);
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChangeCaseNoView.vue